function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.333,3H4.667A1.668,1.668,0,0,0,3,4.667V16.333A1.668,1.668,0,0,0,4.667,18H16.333A1.668,1.668,0,0,0,18,16.333V4.667A1.668,1.668,0,0,0,16.333,3ZM13,16.333H11.333v-2.5L12.167,13l.833.833Zm0-9.167H8V5.5h5Zm3.333,9.167H14.667v-2.5L15.5,13l.833.833Z",
  transform: "translate(-3 -3)",
  fill: "#949db2"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/order-fulfillment.081066da.svg";
export { SvgComponent as ReactComponent };